import { TableRow, TableCell, Box } from "@mui/material";
import { Indentation } from "./rowTypes";
import { ReactNode } from "react";

type SectionRowProps = Indentation & {
  children: ReactNode;
  colSpan?: number;
};

export function SectionRow({
  xWidth,
  xGap,
  children,
  colSpan = 6,
}: Readonly<SectionRowProps>) {
  return (
    <TableRow
      sx={{
        "& > td": {
          borderBottom: 0,
        },
      }}
    >
      <TableCell
        colSpan={colSpan}
        sx={(theme) => ({
          px: 2,
          pt: 0,
          pb: 2,
          pl: `calc(${theme.spacing(2)} + ${xWidth}px + ${theme.spacing(xGap)})`,
        })}
      >
        <Box
          sx={{
            px: 2.5,
            py: 0.75,
          }}
        >
          {children}
        </Box>
      </TableCell>
    </TableRow>
  );
}
